import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { PopupStep } from "../PopupStep/PopupStep";
import questionIcon from "../../assets/images/step-icon/question.png";
import {
  clearResumeStep,
  getResumeStep,
  getStepLabel,
  getStepNumber,
  totalSteps
} from "../../utils/resumeStep";

// Hỏi user có muốn quay lại step đang làm dở hay không.
export const ResumeStepPopup = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(() => getResumeStep());

  if (!step) return null;

  const stepNumber = getStepNumber(step);
  const stepLabel = getStepLabel(step);
  const description = stepNumber
    ? `You stopped at step ${stepNumber}/${totalSteps}${
        stepLabel ? `: ${stepLabel}` : ""
      }`
    : stepLabel;

  return (
    <PopupStep
      icon={questionIcon}
      title="Welcome back! Continue where you left off?"
      email={description}
      buttonsDirection="row"
      buttons={[
        {
          title: "Continue",
          onClick: () => navigate(`/${step}`)
        },
        {
          title: "Start over",
          onClick: () => {
            clearResumeStep();
            setStep(null);
          }
        }
      ]}
    />
  );
};

export default ResumeStepPopup;
